import { Div } from '../../../../base/components/native/div'
import { CENTER, EASE } from '../../../../base/helpers/style'

export const AssistantGenrerate = () => {

    const base = Div('🪄 Generate your art')

    base.cssClass({
        ...CENTER,
        ...EASE(.16),
        height: '50px',
        borderRadius: '10px',
        backgroundColor: '#ECECEF',
        marginTop: '10px',
        fontSize: '18px',
        fontWeight: '600',
        lineHeight: '21px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#DADCE0'
        }
    })

    return base
}
